import { render } from "./TagSelection.vue?vue&type=template&id=f9bdb12a&ts=true"
import script from "./TagSelection.vue?vue&type=script&lang=ts"
export * from "./TagSelection.vue?vue&type=script&lang=ts"

import "./TagSelection.vue?vue&type=style&index=0&id=f9bdb12a&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__